import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, GiftIcon, BookOpenIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const meta = [{
  icon: DownloadIcon,
  label: 'Acceso inmediato'
}, {
  icon: BookOpenIcon,
  label: '6 tomos digitales'
}, {
  icon: GiftIcon,
  label: '5 bonos incluidos'
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-cream" data-id="element-73" data-mp="4jm7tt5w3bt7">
      <div className="blueprint-grid absolute inset-0" aria-hidden="true" data-id="element-74" data-mp="12862k3i3uktp" />
      <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-b from-transparent to-cream" aria-hidden="true" data-id="element-75" data-mp="xa4j3hgrojhp" />

      <div className="relative mx-auto grid max-w-6xl gap-12 px-5 pb-16 pt-10 sm:px-8 sm:pb-20 sm:pt-14 lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-10 lg:pb-24" data-id="element-76" data-mp="s9zwrat6gujk">
        <div data-id="element-77" data-mp="3d21v45faeyrf">
          <motion.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 rounded-full border-2 border-ink bg-sand px-4 py-2 text-[11px] font-bold uppercase tracking-[0.16em]" data-id="element-78" data-mp="3d2l9jc5qb50p">
            Libro digital · 6 tomos + 5 bonos gratis
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.08
        }} className="mt-6 font-display text-[2.5rem] font-bold leading-[1.02] tracking-tight sm:text-6xl lg:text-[4.1rem]" data-id="element-79" data-mp="399ba3kjqp7ue">
            Aprendé a colgar repisas, cortinas y arreglar tu casa{' '}
            <span className="relative inline-block" data-id="element-80" data-mp="2qk3m2o09mion">
              <span className="relative z-10" data-id="element-81" data-mp="2qlofuber9xlg">sin miedo</span>
              <span className="absolute -bottom-1 left-0 z-0 h-3 w-full bg-clay/30" aria-hidden="true" data-id="element-82" data-mp="2vi5558xoyi04" />
            </span>{' '}
            y sin experiencia
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.16
        }} className="mt-6 max-w-xl text-lg leading-relaxed text-graphite" data-id="element-83" data-mp="2lk8u0h4r7n20">
            Una guía práctica paso a paso para padres y madres que quieren
            resolver arreglos simples del hogar sin depender siempre de alguien
            más.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.24
        }} className="mt-9" data-id="element-84" data-mp="1b0vubd1tv0cg">
            <div className="flex flex-wrap items-center gap-5" data-id="element-85" data-mp="112g6pk20e97p">
              <CtaButton size="lg" href="#oferta" data-id="element-86" data-mp="114sw2ia3jlus">
                Quiero acceso inmediato
              </CtaButton>
              <p className="font-display text-lg font-bold" data-id="element-87" data-mp="x3h62bnb8ym2">
                $28.990{' '}
                <span className="font-sans text-sm font-medium text-graphite" data-id="element-88" data-mp="3lqm1rwhul1tv">
                  · único pago
                </span>
              </p>
            </div>
          </motion.div>

          <ul className="mt-8 flex flex-wrap gap-x-6 gap-y-3" data-id="element-89" data-mp="1x784bltydnt2">
            {meta.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-2 text-sm font-medium text-graphite" data-id="element-90" data-mp="269zihte7qxoe">
                <Icon className="h-4 w-4 text-clay" aria-hidden="true" data-id="element-91" data-mp="2b1hjuik5f09w" />
                {label}
              </li>)}
          </ul>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.1
      }} className="relative" data-id="element-92" data-mp="2kyvqxrk6mcpj">
          <div className="overflow-hidden rounded-3xl border-2 border-ink bg-sand shadow-block" data-id="element-93" data-mp="2tzbokke8upmh">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/e501e7e2-1735-4870-aabc-7cde1a9f5174.jpg" alt="Los 6 tomos de Manos a la Casa en formato digital, sobre una mesa de taller" className="h-full w-full object-cover" data-id="element-94" data-mp="umpqo3f6hozj" />
          </div>
          <div className="absolute -bottom-5 left-4 rotate-[-3deg] rounded-xl border-2 border-ink bg-cream px-4 py-2 font-display text-sm font-bold shadow-blockSm sm:left-8" data-id="element-95" data-mp="3vi714skacoxd">
            Descarga digital · Sin envíos
          </div>
        </motion.div>
      </div>
    </header>;
}